import React, { Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import PublicRoute from 'Components/route/publicRoute'
import Loading from 'Components/loading'

import CustomRoute from 'Components/route/customRoute'
import HomeScreen from 'Modules/home'
import { useRoot } from 'Hooks'
import Overlay from 'Components/form/overlay'
import ModalError from 'Components/modalError'
import { ROUTES } from './constant'
import PrivateRoute from '../Components/route/privateRoute'

export default function AppRoutes() {
  const { isShowOverlay } = useRoot()
  return (
    <>
      <Suspense fallback={<Loading />}>
        <Switch>
          <CustomRoute exact path="/" component={HomeScreen} />
          {ROUTES.map((routeConfig, index) => {
            if (routeConfig.isAuth) {
              return (
                <PrivateRoute
                  key={index}
                  exact
                  {...routeConfig}
                />
              )
            }
            return (
              <PublicRoute
                key={index}
                exact
                {...routeConfig}
              />
            )
          })}
          <Route path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
        {isShowOverlay && <Overlay />}
        <ModalError />
      </Suspense>
    </>
  )
}
